import {Injectable} from '@angular/core';
import {DataTabs} from '../../shared/models/tabs-data';
import {GetConfigCompaniesService} from './get-config-company.service';
import {select, Store} from '@ngrx/store';
import * as fromCompanies from '../reducers';
import {ContractDataService} from '../../contract/services/contract-data.service';
import {Observable} from 'rxjs';
import {map, skipWhile} from 'rxjs/operators';
import {CompanyMapperService} from './company-mapper.service';
import {Company, CompanyForm} from '../models/company';
import {GetCompanyFormsService} from './get-forms.service';
import {GetFormsService} from '../../shared/services/get-forms.service';
import {GetConfigSharedService} from '../../shared/services/get-config-shared.service';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class CompanyDataService {
  constructor(private getCompanyFormsService: GetCompanyFormsService,
              private getConfigCompaniesService: GetConfigCompaniesService,
              private storeCompany: Store<fromCompanies.AppState>,
              private contractDataService: ContractDataService,
              private getFormsService: GetFormsService,
              private getConfigSharedService: GetConfigSharedService,
              private companyMapperService: CompanyMapperService) {
  }

  getCompaniesListData(): DataTabs {
    return {
      dataTabs: [
        {
          titleTab: 'Companies',
          contentTab: 'datatableCompaniesList',
          dataConfig: {
            form: this.getCompanyFormsService.getFilterCompanies(),
            groupConfigs: this.getConfigCompaniesService.getCompaniesConfigs(),
            header : {
              icon: 'fal fa-city',
              text: 'GENERIC_COMPANIES',
              rightSideButton : {
                buttonTitle : 'COMPANIES_NEW_TITLE',
                buttonIcon: 'fas fa-plus',
                action: 'link',
                href : ['/', 'companies', 'add'],
                role: 'BO_BILLING_CREATE_COMPANY'
              },
            },
            content: [
              {
                name: 'GENERIC_NAME_LABEL',
                prop: 'name',
                sortable: true,
                type: 'detailRouterLink',
                path: 'contract'
              },
              {
                name: '',
                prop: 'countryCode',
                sortable: true,
                type: 'country',
              },
              {
                name: 'GENERIC_ADDRESS',
                prop: 'line1',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_ZIP',
                prop: 'zip',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_CITY',
                prop: 'city',
                sortable: true,
                type: 'text'
              },
              // {
              //   name: 'GENERIC_STATUS',
              //   prop: '',
              //   type: 'iconList',
              //   data: [
              //     {class: 'fa-file-signature fal' , tooltip: 'Number of contract: ' , extra: 'contractCount'},
              //     {class: 'fa-building fal' , tooltip: 'Number of subscriptions: ' , extra: 'subscriptionTotalCount'},
              //     {class: 'fa fa-flag fa-fw' , tooltip: 'Number of exploit subscriptions: ' , extra: 'subscriptionExploitCount'},
              //     ]
              // },
              {
                name: 'COMPANY_CONTRACT_COUNT',
                prop: 'contractCount',
                type: 'text'
              },
              {
                name: 'CONTRACT_SUBSCRIPTION_COUNTS',
                prop: 'subscriptionTotalCount',
                type: 'concatenate',
                concatenate: ['Exploit: ' , 'subscriptionExploitCount', ' Total: ' , 'subscriptionTotalCount'],
              },
              {
                name: 'GENERIC_CODE',
                prop: 'logisticsIdentifier',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_SAP_CODE',
                prop: 'sapCode',
                sortable: true,
                type: 'text'
              },
              // {
              //   name: 'GENERIC_CLIENT',
              //   prop: 'clientName',
              //   sortable: true,
              //   type: 'routerLink',
              //   path: 'ClientName'
              // },
              {
                name: 'GENERIC_OFFICE',
                prop: 'officeID',
                sortable: true,
                array: [  { id: 1, name: 'OFFICE_BE' },
                          { id: 2, name: 'OFFICE_FR' },
                          { id: 3, name: 'OFFICE_ES' },
                          { id: 4, name: 'OFFICE_DE' },
                          { id: 5, name: 'OFFICE_CN' },
                          { id: 6, name: 'OFFICE_IT' },
                          { id: 7, name: 'OFFICE_NL' },
                          { id: 8, name: 'OFFICE_UK' },
                          { id: 9, name: 'OFFICE_HK' }],
                type: 'array'
              },
              {
                name: 'GENERIC_CREATED',
                prop: 'created',
                sortable: true,
                type: 'date'
              },
              // {
              //   name: 'GENERIC_VAT',
              //   prop: 'vat',
              //   sortable: true,
              //   type: 'text'
              // },

            ]
          },
        }
      ]
    }
  }
  getCompanySubListData(): DataTabs {
    return {
      dataTabs: [
        {
          titleTab: 'Subscription',
          contentTab: 'subscriptionsList',
          dataConfig: {
            form: this.getCompanyFormsService.getFilterSubscription(),
            groupConfigs: this.getConfigCompaniesService.getSubscriptionFilter(),
            header :  {
              exportExcel: true,
              icon: 'fal fa-building',
              text: 'GENERIC_SUBSCRIPTION_NAME',
              // rightSideButton: {
              //   buttonTitle: 'CONTRACT_LINK_MODAL_LINK_CONTRACT',
              //   buttonIcon: 'fad fa-link',
              //   action: 'openModal',
              // },
              } ,
            content: [
              {
                name: 'checkBox',
                prop: 'checkBox',
                sortable: false,
                type: 'checkBox'
              },
              {
                name: '',
                prop: 'serviceId',
                sortable: true,
                type: 'service'
              },
              {
                name: 'GENERIC_SUBSCRIPTION_NAME',
                prop: 'subscriptionName',
                sortable: true,
                type: 'detailRouterLink',
                path: 'SubName',
              },
              {
                name: 'GENERIC_STATUS',
                prop: 'status',
                sortable: true,
                type: 'iconListSwitch',
                data: [
                  {tooltip: 'SUBSCRIPTIONS_STATUS_EXPLOIT' , icon: 'fa fa-fw fa-flag text-success', value: 3 },
                  {tooltip: 'SUBSCRIPTIONS_STATUS_DEMO' , icon: 'fa fa-fw fa-flask text-info', value: 2 },
                  {tooltip: 'SUBSCRIPTIONS_STATUS_OFF' , icon: 'fa fa-fw fa-power-off text-danger', value: 1 },
                  {tooltip: 'SUBSCRIPTIONS_STATUS_TO_OFF' , icon: 'fa fa-fw fa-flag-checkered text-warning', value: 0 },
                  {tooltip: 'SUBSCRIPTIONS_STATUS_STOP' , icon: 'fa fa-fw fa-stop text-danger', value: -1 },
                  {tooltip: 'SUBSCRIPTIONS_STATUS_BANKRUPTCY' , icon: 'fas fa-university text-danger', value: -2 }
                ]
              },
              {
                name: 'GENERIC_CLIENT',
                prop: 'clientName',
                sortable: true,
                type: 'routerLink',
                path: 'clientName',
              },
              {
                name: 'GENERIC_START_DATE',
                prop: 'startBilling',
                sortable: true,
                type: 'date'
              },
              {
                name: 'GENERIC_END_DATE',
                prop: 'endBilling',
                sortable: true,
                type: 'date'
              },
              {
                name: 'ORDERS_LIST_DELIVERY_DATE',
                prop: 'deliveryDate',
                sortable: true,
                type: 'date'
              },
              {
                name: 'GENERIC_PRICE',
                prop: 'price',
                sortable: true,
                type: 'concatenatePrice',
                concatenate: ['price', 'currencyIsoCode'],
                emptyData: 'CONTRACT_LIST_PRICE_EMPTY_DATA',
              },

              {
                name: 'GENERIC_CONTRACT_NAME',
                prop: 'contractName',
                sortable: true,
                type: 'routerLink',
                path: 'contractName',
              },
              {
                name: 'GENERIC_PRODUCT',
                prop: 'productName',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_PLAYER_NAME',
                prop: 'playerName',
                sortable: true,
                type: 'externalPortal'
              },
              {
                name: 'GENERIC_LAST_INVOICE_CALCULATION',
                prop: 'lastInvoiceCalculation',
                sortable: true,
                type: 'date'
              },
              {
                name: 'M_MENU_C_CONTEXTUEL',
                prop: '',
                sortable: false,
                type: 'iconModal',
                icon: {
                  modal: 'CloseSiteBillingModal',
                  class: 'fal fa-window-close',
                  tooltip: 'CONTRACT_CLOSE_SITE_BILLING_MODAL_TITLE',
                  disabledFn: (row): boolean => (row.status === 1 && (moment(row.endBilling).year() < new Date().getFullYear()) ),
                }
              },
            ]
          },
        }
      ]
    }
  }
  getCompanyInvoicesListData(): DataTabs {
    return {
      dataTabs: [
        {
          titleTab: 'Invoices',
          contentTab: 'invoicesList',
          dataConfig: {
            form: this.getFormsService.getFilterCompanyInvoices(),
            groupConfigs: this.getConfigSharedService.getInvoicesilter(),
            header :  {
              icon: 'fal fa-wallet',
              text: 'GENERIC_INVOICES'
            } ,
            content: [
              // {
              //   name: 'GENERIC_CONTRACT_NAME',
              //   prop: 'contractName',
              //   sortable: true,
              //   type: 'routerLink',
              //   path: 'invoicesDetail',
              // },
              {
                name: 'GENERIC_CODE',
                prop: 'code',
                sortable: true,
                type: 'text',
              },
              {
                name: 'INVOICES_LOGISTIC_JOURNAL',
                prop: 'logisticJournal',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_COVERS_START',
                prop: 'coverStart',
                sortable: true,
                type: 'date'
              },
              {
                name: 'GENERIC_COVERS_END',
                prop: 'coverEnd',
                sortable: true,
                type: 'date'
              },
              {
                name: 'CONTRACT_PURCHASE_ORDER',
                prop: 'purchaseOrder',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_INVOICE_NUMBER',
                prop: 'number',
                sortable: true,
                type: 'detailRouterLinkSplit',
                splitChar: ',',
                path: 'invoicesDetail',
              },
              {
                name: 'GENERIC_SPLIT',
                prop: 'split',
                sortable: true,
                type: 'select',
                data: [
                  { id: 1, name: 'PO' },
                  { id: 2, name: 'Site' },
                  { id: 3, name: 'Country' },
                  { id: 4, name: 'Contract' },
                  { id: 5, name: 'Client' },
                  { id: 6, name: 'Company' },
                ]
              },
              {
                name: '' ,
                prop: 'isAdjustment',
                sortable: false,

                type: 'icon',
                icon: {
                  classFn: (row): string => (row.isAdjustment ? 'far fa-file-invoice-dollar' : ''),
                  tooltip: 'GENERIC_INVOICE_IS_ADJUSTMENT'
                }
              },
              {
                name: 'GENERIC_COUNTRY',
                prop: 'countryCode',
                sortable: true,
                type: 'country',
              },
              {
                name: 'GENERIC_OFFICE',
                prop: 'officeID',
                sortable: true,
                array: [  { id: 1, name: 'OFFICE_BE' },
                          { id: 2, name: 'OFFICE_FR' },
                          { id: 3, name: 'OFFICE_ES' },
                          { id: 4, name: 'OFFICE_DE' },
                          { id: 5, name: 'OFFICE_CN' },
                          { id: 6, name: 'OFFICE_IT' },
                          { id: 7, name: 'OFFICE_NL' },
                          { id: 8, name: 'OFFICE_UK' },
                          { id: 9, name: 'OFFICE_HK' }],
                type: 'array'
              },
              {
                name: 'GENERIC_TOTAL',
                prop: 'total',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_CREATED',
                prop: 'created',
                sortable: true,
                type: 'date',
              }
            ]
          },
        }
      ]
    }
  }

  getCompanyDetailsData(): DataTabs {
    return {
      dataTabs: [
        {
          titleTab: 'Company',
          contentTab: 'companyDisplay',
          dataConfig: {
            form: this.getCompanyFormsService.getCompany(),
            groupConfigs: this.getConfigCompaniesService.getCompanyConfigs(),
            content: this.mapDataCompanyToForm(this.storeCompany.pipe(select(fromCompanies.selectors.getCompany))),
          }
        },
        {
          titleTab: 'Contracts',
          contentTab: 'datatableContracts',
          dataConfig: this.contractDataService.getContractsListData().dataTabs[0].dataConfig,
        },
        {
          titleTab: 'Subscription',
          contentTab: 'subscriptionsList',
          dataConfig: this.getCompanySubListData().dataTabs[0].dataConfig,

        },
        {
          titleTab: 'Invoices',
          contentTab: 'invoicesList',
          dataConfig: this.getCompanyInvoicesListData().dataTabs[0].dataConfig,

        },
      ]
    }
  }
  getCompanyDetailsDataSimple(): DataTabs {
    return {
      dataTabs: [
        {
          titleTab: 'Company',
          contentTab: 'companyDisplay',
          dataConfig: {
            form: this.getCompanyFormsService.getCompany(),
            groupConfigs: this.getConfigCompaniesService.getCompanyConfigsSimple(),
            content: this.mapDataCompanyToForm(this.storeCompany.pipe(select(fromCompanies.selectors.getCompany))),
          }
        },
        {
          titleTab: 'Contracts',
          contentTab: 'datatableContracts',
          dataConfig: this.contractDataService.getContractsListData().dataTabs[0].dataConfig,
        },
        {
          titleTab: 'Subscription',
          contentTab: 'subscriptionsList',
          dataConfig: this.getCompanySubListData().dataTabs[0].dataConfig,

        },
        {
          titleTab: 'Invoices',
          contentTab: 'invoicesList',
          dataConfig: this.getCompanyInvoicesListData().dataTabs[0].dataConfig,

        },
      ]
    }
  }
  getCompanyDetailsAdd(): DataTabs {
    return {
      dataTabs: [
        {
          titleTab: 'Company',
          contentTab: 'companyDisplay',
          dataConfig: {
            form: this.getCompanyFormsService.getCompany(),
            groupConfigs: this.getConfigCompaniesService.getAddCompanyConfigs(),
            content: this.mapDataCompanyToForm(this.storeCompany.pipe(select(fromCompanies.selectors.getCompany))),
          }
        },
      ]
    }
  }

  mapDataCompanyToForm(data: Observable<Company>): Observable<CompanyForm> {
    return data.pipe(
      skipWhile((c: Company) => !c),
      map(company => this.companyMapperService.dbToForm(company))
    )
  }
}


